import { useSelector } from 'react-redux';
import { getGlobalVariableSelector } from '@store/global-variables';
import { calculateBasketTotalsFromItems } from '@helpers/basket';
export var useBasketTotals = function useBasketTotals() {
  var storedTotals = useSelector(getGlobalVariableSelector('basketTotals'));
  var basket = useSelector(getGlobalVariableSelector('basket'));

  if (storedTotals) {
    return storedTotals;
  }

  return calculateBasketTotalsFromItems(basket !== null && basket !== void 0 ? basket : []);
};